import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
  hideBackground: PropTypes.bool,
  isRound: PropTypes.bool
};

const defaultProps = {
  hideBackground: false,
  isRound: false
};

function ProductReview(props) {
  const { hideBackground, isRound, ...rest } = props;

  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...rest}>
      {!hideBackground && <rect fill="#88BF61" height="24" rx={isRound ? '100%' : 0} width="24" />}
      <g clipPath="url(#clip0_2593_21946)">
        <path
          d="M11.9998 5.49779C15.2369 5.49779 17.8722 8.07399 17.8722 11.2386C17.8722 12.5018 17.4607 13.7001 16.6818 14.7038L16.2946 15.2013L16.4517 15.8069L16.83 17.267L15.4781 16.5597L14.9139 16.2633L14.3253 16.5121C13.5885 16.8236 12.8074 16.9793 11.9998 16.9793C8.76268 16.9793 6.1274 14.4031 6.1274 11.2386C6.1274 8.07399 8.76268 5.49779 11.9998 5.49779ZM11.9998 4.19995C8.02365 4.19995 4.7998 7.35153 4.7998 11.2386C4.7998 15.1256 8.02365 18.2772 11.9998 18.2772C13.0132 18.2772 13.9757 18.0717 14.8497 17.7018L18.8546 19.8L17.7372 15.4868C18.6533 14.3058 19.1976 12.8349 19.1976 11.2364C19.1998 7.35153 15.976 4.19995 11.9998 4.19995Z"
          fill="#003F2C"
        />
        <path
          d="M12.0132 10.4145C12.0132 10.4145 12.6261 14.0181 12.6792 14.7904C13.5731 14.4486 15.1242 13.4276 15.7216 12.7527C15.726 11.4722 15.6707 10.1073 15.029 8.68835C13.5997 9.55574 12.0132 10.4123 12.0132 10.4123V10.4145Z"
          fill="#003F2C"
        />
        <path
          d="M11.5045 10.488C11.5045 10.488 11.9337 13.7326 12.2413 14.8141C11.2788 14.7665 9.34048 14.0917 8.55499 13.6374C8.13458 12.4218 8.00625 11.323 8.02174 9.7915C9.66353 10.1722 11.5067 10.488 11.5067 10.488H11.5045Z"
          fill="#003F2C"
        />
        <path
          d="M14.7432 8.37895C13.8448 8.90674 11.7141 10.0532 11.7141 10.0532C11.7141 10.0532 9.154 9.53186 8.24902 9.33935C8.74466 8.96082 10.5059 7.80141 11.4861 7.74734C12.3402 7.71057 13.8957 7.98311 14.7432 8.37895Z"
          fill="#003F2C"
        />
      </g>
      <defs>
        <clipPath id="clip0_2593_21946">
          <rect fill="white" height="15.6" transform="translate(4.7998 4.19995)" width="14.4" />
        </clipPath>
      </defs>
    </svg>
  );
}

ProductReview.propTypes = propTypes;
ProductReview.defaultProps = defaultProps;

export default ProductReview;
